import React from 'react';
import PropTypes from 'prop-types';
import Location from './Location';
import ProjectActions from './ProjectActions';
import { useAppSettings } from 'utilities/hooks';
import { getFormattedDate } from 'utilities';
import { SHORT_FORMAT_DATE_OPTIONS, URLS } from 'consts';

// Component used on job posts view - projects with either `draft` or `pending_approval` status
function Draft(props) {
  const { project_removal } = useAppSettings();
  const {
    city_state_list,
    id,
    project_title,
    posted_by,
    remote_percentage,
    start_date,
    status,
  } = props.draft.attributes;
  const { view_project_link } = props.draft.links;

  const startDateFormatted = start_date
    ? getFormattedDate(
        new Date(start_date + 'T00:00:00'),
        SHORT_FORMAT_DATE_OPTIONS,
      )
    : 'N/A';

  return (
    <div className="project">
      <div className="box box-md box-shadow-sm">
        <div className="row">
          <div className="basic-info col-lg-6">
            <div className="title font-md">{project_title}</div>
          </div>
          <ProjectActions
            viewPath={view_project_link}
            showProjectRemoval={project_removal}
            projectSlug={id}
          />
        </div>
        <div className="secondary-info row justify-content-between">
          <div className="col-md-3 text-left pl-0 pb-3 pb-lg-0">
            <span className="font-heavy d-block mb-1">Start date</span>
            {startDateFormatted}
          </div>
          <div className="col-md-3 text-left pl-0 pb-3 pb-lg-0">
            <span className="font-heavy d-block mb-1">Created by</span>
            {posted_by}
          </div>
          <Location
            cityStateList={city_state_list}
            remotePercentage={remote_percentage}
            containerClassnames="col-md-3"
          />
          <div className="edit-container col-md-3 pr-0">
            <a
              id={`edit-${id}`}
              href={
                status !== 'draft'
                  ? URLS.employerProjectReview(id)
                  : props.draft.links.edit_project_link
              }
              className="tmp-btn lg btn-edit-job"
            >
              Edit job
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
Draft.propTypes = {
  draft: PropTypes.object.isRequired,
};
export default Draft;
